module.exports = __webpack_public_path__ + "img/eur-currency-icon.b56e3020.svg";